import CyrexProductDetail from "@/components/organisations/shop/ui/CyrexProductDetail";
import ReportDetail from "@/components/organisations/shop/ui/ReportDetail";
import TestProductDetail from "@/components/organisations/shop/ui/TestProductDetail";
import { useTestProductModalContext } from "@/contexts/TestProductModalContext";
import { TEST_PRODUCT_LISTING_CMP_REPORTS } from "@/core/constants";
import BaseTestProductModal from "@/tpo/shop/BaseTestProductModal";

function ProductDetailView() {
  const { testProduct } = useTestProductModalContext();

  if (!testProduct) {
    return null;
  }

  if (testProduct.isCyrex && testProduct.productCode !== "CYX02") {
    return <CyrexProductDetail />;
  }

  if (testProduct.listingVisibility === TEST_PRODUCT_LISTING_CMP_REPORTS) {
    return <ReportDetail />;
  }

  return <TestProductDetail />;
}

export default function TestProductModal({ bg }) {
  return (
    <BaseTestProductModal
      productDetailView={<ProductDetailView />}
      organisationShop={true}
      bg={bg}
    />
  );
}
